module.exports = __webpack_public_path__ + "flags.ae33acae404631e997ef.png";


//////////////////
// WEBPACK FOOTER
// ./~/ngx-intl-tel-input/resource/img/flags.png
// module id = 833
// module chunks = 2